import { Label } from '@procurify/ui'

import { WithOrderItemTooltip } from '@webapp/components/OrderItemTooltip/WithOrderItemTooltip'
import { type OrderItem } from '@webapp/models/OrderItem'

export interface UnbilledItemPOLabelProps {
  orderItem: OrderItem | null
  poNumber: string
}

export const UnbilledItemPOLabel = ({
  orderItem,
  poNumber,
}: UnbilledItemPOLabelProps) =>
  orderItem ? (
    <WithOrderItemTooltip item={orderItem}>
      <Label label='PO'>{poNumber}</Label>
    </WithOrderItemTooltip>
  ) : (
    <Label label='PO'>{poNumber}</Label>
  )
